var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 230,
    viewBox: "0 0 259 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.193 0.833008C207.327 0.833008 258.473 52.208 258.473 115C258.473 177.791 207.327 229.166 144.193 229.166C104.12 229.166 69.0708 208.388 48.635 176.992L66.6733 162.721C82.7708 188.865 111.427 206.333 144.307 206.333C168.53 206.333 191.761 196.71 208.889 179.582C226.017 162.454 235.64 139.223 235.64 115C235.64 90.7766 226.017 67.5456 208.889 50.4173C191.761 33.2889 168.53 23.6663 144.307 23.6663C97.7267 23.6663 59.3667 58.6013 53.7725 103.583H85.2825L42.5842 146.167L0 103.583H30.7108C36.4192 45.9288 85.0542 0.833008 144.193 0.833008ZM177.986 94.9063C183.694 95.0205 188.375 99.5872 188.375 105.41V158.04C188.375 163.749 183.694 168.544 177.872 168.544H114.738C108.915 168.544 104.234 163.749 104.234 158.04V105.41C104.234 99.5872 108.915 95.0205 114.623 94.9063V83.3755C114.623 65.908 128.894 51.7513 146.248 51.7513C163.715 51.7513 177.986 65.908 177.986 83.3755V94.9063ZM146.248 67.7347C137.685 67.7347 130.607 74.6988 130.607 83.3755V94.9063H162.003V83.3755C162.003 74.6988 154.924 67.7347 146.248 67.7347Z",
    fill: "#1165BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.873037ec96b6636da946d8dce26d05d5.svg";
export { ForwardRef as ReactComponent };